import { client } from '$lib/api/Client';
import { toastError } from '$utils/toasts';

export const sendChatMessage = async (
  receiverId: number,
  messageContent: string,
) => {
  try {
    if (!receiverId) {
      toastError({
        position: 'bottom-center',
        title: 'Error',
        message:
          'Something went wrong. We are not able to find the user you are looking for.',
      });
      return;
    }

    const { conversationId } = await client.chats.createMessage({
      receiverId,
      content: messageContent,
    });

    return conversationId;
  } catch (error) {
    console.log(error);

    toastError({
      position: 'bottom-center',
      title: 'Error',
      message:
        'Something went wrong while sending the message. Please try again.',
    });
  }
};
